import React from 'react';
import cx from 'classnames';
import { NavBar } from '../../NavBar/NavBar';

import QueueTableBody from './QueueTableBody';

export const QueueTable = React.memo(
  ({
    className,
    headerOptions = null,
    rows,
    isLoading,
    title,
    mini = false,
    id,
    stages,
    disabledStatuses = [],
    switchModel,
    disableProgressAnimations = false,
  }) => {

    return (
      <div id={id} className={cx('custom-table__container', className)}>
        {title || switchModel ? (
          <div className="queue-table__header">
            {title ? (
              <div className="queue-table__title">
                {title}
              </div>
            ) : null}
            
            {switchModel && (
              <NavBar
                className="nav-bar__custom-width queue-table__switch"
                containerClassName="queue-table__switch-container"
                itemWidth={switchModel.width}
                navTabs={switchModel.options}
                activeTab={switchModel.activeTab}
                onChange={switchModel.onChange}
              />
            )}
          </div>
        ) : null}

        <div className="custom-table__wrapper">
          <QueueTableBody
            headerOptions={headerOptions}
            rows={rows}
            isLoading={isLoading}
            mini={mini}
            stages={stages}
            disabledStatuses={disabledStatuses}
            disableProgressAnimations={disableProgressAnimations}
          />
        </div>
      </div>
    );
  }
);
